export function htmlExtractText(html) {
	if (!html) {
		return '';
	}

	let text;
	// fire up a parser
	const parser = new DOMParser();
	// injest the html
	const doc = parser.parseFromString(html, 'text/html');
	// if DOMParser has an error, it returns an xml string where the documentElement.nodeName is 'parserror'
	if (
		doc &&
		doc.documentElement &&
		doc.documentElement.nodeName &&
		doc.documentElement.nodeName.toUpperCase() == 'HTML'
	) {
		// remove non-content nodes
		[].forEach.call(doc.querySelectorAll('script, style, noscript'), node => node.parentNode.removeChild(node));
		// get the text content
		text = doc.documentElement.textContent;
	} else {
		text = html
			// discard doctype and xml
			.replace(/<!doctype[^>]+>/gi, '')
			.replace(/<\?xml[^>]+>/gi, '')
			// remove tags and contents for scripts, styles and comments
			.replace(/<(script|noscript|style)[^>]*>.*?<\/\1>/gi, '')
			.replace(/<!--.+?-->/gi, '')
			// convert br to newlines
			.replace(/<br(|\s*\/)>/gi, '\n')
			// change some tags and contents into a single space
			.replace(/<(canvas|caption|figcaption|figure)[^>]*>.*?<\/\1>/gi, ' ')
			// replace block end tags with a newline
			.replace(
				/<\/(address|article|aside|audio|blockquote|center|col|del|dd|div|dl|fieldset|footer|form|frame|frameset|h1|h2|h3|h4|h5|h6|header|hgroup|iframe|ins|li|nav|noframes|noscript|object|ol|output|p|pre|script|section|table|tbody|tfoot|thead|tr|ul|video)>/gi,
				'\n'
			)
			// replace some tags with a space
			.replace(/<\/(td|dt)>/gi, ' ')
			// remove all other open and close tags
			.replace(/<\/?[a-z].*?>/gi, '');
	}
	// normalize whitespace
	text = text
		// change multiple newlines to a single one
		.replace(/[\r\n]+/g, '\n')
		// replace tabs and spaces with a single space
		.replace(/[\t ]+/g, ' ')
		// now we may be left with newline spaces instead of newlines
		.replace(/\n /g, '\n')
		// and then make sure we only have on newline in a row
		.replace(/\n+/g, '\n')
		// and trim the ends
		.trim();
	return text;
}
